import { AfterViewInit, ChangeDetectorRef, Component, ComponentRef, Injector, OnDestroy, OnInit, QueryList, ViewChildren, ViewContainerRef } from '@angular/core';
import { DynamicBaseClass } from '../dynamic-base-class/dynamic-base-class.component';
import { Observable, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { GetUiDefinitionResponse } from '../../models/get-ui-definition-response.models';
import { UiComponent } from '../../models/ui-component.models';
import { isArray } from 'lodash-es';

@Component({
  standalone: false,
    selector: 'app-dynamic-ui-definition',
    templateUrl: './ui-definition.component.html',
    styleUrls: ['./ui-definition.component.scss'],
})
export class UiDefinitionComponent
    extends DynamicBaseClass
    implements OnInit, OnDestroy, AfterViewInit {
    componentRef: ComponentRef<DynamicBaseClass>;
    uiDefinition$: Observable<any>;
    subscriptions: Subscription = new Subscription();
    reloadOnDataStoresChanged: string[] = [];

    uiComponents: UiComponent[] = [];

    @ViewChildren('children', { read: ViewContainerRef }) viewChildrenRef: QueryList<ViewContainerRef>;

    private name: string;
    private defaultUiDefinitionName: string;
    private firstStart: boolean = true;

    public value$: Observable<string>;
    public isInitialized: boolean = false;

    constructor(
        injector: Injector,
        private cdr: ChangeDetectorRef
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.value$ = this.GetValueFromConfig();
        if (!this.config?.name) { throw new Error("UI Definition Component requires a name in the config."); }
        if (this.config) {
            this.name = this.config.name;
            //console.log(' ***** UI definition control init', this.name, this.storeDataChildNames);
            this.defaultUiDefinitionName = this.config.defaultUiDefinitionName;
            if (this.config.reloadOnDataStoresChanged && Array.isArray(this.config.reloadOnDataStoresChanged)) {
                this.reloadOnDataStoresChanged = this.config.reloadOnDataStoresChanged;
                this.reloadOnDataStoresChanged.forEach(ds => {
                    this.subscription$.add(
                        this.dynamicUiServices.GetValueAsObservable(ds, this.storeDataChildNames, true).subscribe(value => {
                            //console.log(' ***** UI definition control changed, updating view.', this.name, value);
                            //console.log(`Data store ${ds} changed, reloading UI definition. Value: ${value}`);
                            this.LoadUiDefinition();
                            //this.dynamicFacade.InitChildStore(this.uiComponents, this.storeDataChildNames, this.name);
                        })
                    );
                });
            }
        }
    }

    ngAfterViewInit(): void {
        setTimeout(() => this.LoadUiDefinition());
    }

    private LoadUiDefinition(): void {
        this.value$
            .pipe(
                first()
            )
            .subscribe((value) => {
                if (!value && this.defaultUiDefinitionName) {
                    value = this.defaultUiDefinitionName;
                }
                if (value) {
                    this.ClearView();
                    this.uiComponents = [];
                    this.subscriptions.unsubscribe();
                    this.dynamicUiServices.GetUiDefinitionFromName(value, "", "", "")
                        .pipe(
                            takeUntil(this.destroy$)
                        )
                        .subscribe((response: GetUiDefinitionResponse) => {
                            var uiDefinitions = JSON.parse(response.result) as UiComponent[];
                            if (!uiDefinitions || !isArray(uiDefinitions) || uiDefinitions.length === 0) {
                                uiDefinitions = [];
                            }
                            this.InitDynamicComponent(uiDefinitions);
                        });
                }
                else {
                    if (!this.firstStart) {
                        // Reset the UI definition if no value is provided
                        this.ClearView();
                        this.uiComponents = [];
                    }
                }
                this.firstStart = false;
            });
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        //console.log('**** Destroy UI Definition Component', this.name, this.storeDataChildNames);
        //this.dynamicFacade.RemoveActionFromStore(this.storeDataChildNames, this.name);
        super.ngOnDestroy();
    }

    InitDynamicComponent(uiComponents: UiComponent[]): void {
        this.ClearView();
        this.uiComponents = uiComponents;
        this.dynamicFacade.InitChildStore(this.uiComponents, this.storeDataChildNames, this.name);
        this.cdr.detectChanges(); // *ngFor aktualisieren, damit viewChildrenRef befüllt wird
        this.InitView();
    }

    InitView(): void {
        if (this.uiComponents && this.uiComponents.length > 0) {
            setTimeout(() => {
                this.viewChildrenRef.map((vcr: ViewContainerRef, index: number) => {
                    vcr.clear();
                    const component = this.dynamicUiServices.GetComponent(this.uiComponents[index])?.component;
                    if (component) {
                        this.componentRef = vcr.createComponent(component);
                        this.componentRef.instance.children = this.uiComponents[index].children;
                        this.componentRef.instance.config = this.uiComponents[index].config;
                        this.componentRef.instance.storeDataChildNames = [...this.storeDataChildNames, this.name];
                    }
                });
                this.isInitialized = true;
                this.cdr.detectChanges();
            });
        }
    }

    ClearView() {
        this.viewChildrenRef?.map((vcr: ViewContainerRef) => {
            vcr.clear();
        });
        this.componentRef = null;
        this.isInitialized = false;
    }

}
